function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubstance3DAssets = function SvgSubstance3DAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "substance_3d_assets_svg__header-title-link__logo",
    viewBox: "0 0 240 240"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0h155C220.97 0 240 19.52 240 43.59v152.82c0 24.07-19.03 43.59-42.5 43.59h-155C19.03 240 0 220.48 0 196.41V43.59C0 19.52 19.03 0 42.5 0Z",
    style: {
      fill: "#1e3101",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.01 105.76V92.22c0-6.16-3.52-11.78-9.05-14.48l-41.91-20.4a16.129 16.129 0 0 0-14.09 0l-41.91 20.4A16.11 16.11 0 0 0 62 91.96V111.2a9.2 9.2 0 0 0 6.87 8.9l82.23 21.46c.67.17.76 1.09.13 1.38l-27.22 12.89a9.2 9.2 0 0 1-8 0l-23.97-11.56a9.222 9.222 0 0 1-5.21-8.29v-1.48H61.99v13.45a16.1 16.1 0 0 0 9.1 14.5L113 182.67c4.42 2.13 9.57 2.13 13.99 0l41.91-20.22a16.09 16.09 0 0 0 9.08-13.7c.01-.27.02-.53.02-.8v-18.44a9.2 9.2 0 0 0-6.87-8.9L88.43 98.9l.26.06a.74.74 0 0 1-.22-.1.74.74 0 0 1 .09-1.27l27.41-13.42a9.197 9.197 0 0 1 8.06 0L148 95.83a9.197 9.197 0 0 1 5.18 8.28v1.64h24.84Z",
    style: {
      strokeWidth: 0,
      fill: "#99e83f"
    }
  }));
};
export default SvgSubstance3DAssets;